export default __webpack_public_path__ + "static/media/Mitila Esperance conseillere .180696e6.jpg";